const SEARCH_RADIUS =
    Object.freeze(
        {
            '0km': '+0 km',
            '0.5km': '+0.5 km',
            '1km': '+1 km',
            '2km': '+2 km',
            '5km': '+5 km',
            '10km': '+10 km',
            '20km': '+20 km',
            '30km': '+30 km',
            '40km': '+40 km',
            '60km': '+60 km',
            '80km': '+80 km',
            '100km': '+100 km',
        }
    );
export default SEARCH_RADIUS;
